import React from 'react';
import { RouteObject } from 'react-router-dom';
import { appRoutes } from '../../path';
import ProtectedRoute from '../../components/ProtectedRoute';
import { PermissionKey } from '../../utils/apollo/graphqlSchema';
import ScheduleDashboard from './ScheduleDashboard';
import ScheduleAnalysis from './ScheduleAnalysis';
import SidebarLayout from '../../Layout/SidebarLayout';
import ScheduleNav from './ScheduleNav';
import RedirectRoute from '../RedirectRoute';

const scheduleRoutes: RouteObject[] = [
  {
    path: '/schedules/analysis',
    element: (
      <RedirectRoute
        from="/schedules/analysis"
        to={appRoutes.schedules.report}
      />
    ),
  },
  {
    path: '/schedules',
    element: (
      <RedirectRoute from="/schedules" to={appRoutes.schedules.dashboard} />
    ),
  },
  {
    element: (
      <SidebarLayout>
        <ScheduleNav />
      </SidebarLayout>
    ),
    children: [
      {
        path: appRoutes.schedules.dashboard,
        element: (
          <ProtectedRoute
            allRequiredPermissionKeys={[PermissionKey.DashboardScheduleRead]}
            pageNameWithSubPermissions={'schedule'}
          >
            <ScheduleDashboard />
          </ProtectedRoute>
        ),
      },
      {
        path: appRoutes.schedules.report,
        element: (
          <ProtectedRoute
            allRequiredPermissionKeys={[PermissionKey.AnalysisScheduleRead]}
            pageNameWithSubPermissions={'schedule'}
          >
            <ScheduleAnalysis />
          </ProtectedRoute>
        ),
      },
    ],
  },
];

export default scheduleRoutes;
